import { useCallback } from 'react';
import { useGetEditOrActual } from '../../CampaignSettings/selectors/useGetEditOrActual';

export const useGetVariantsSelector = () => {
  const state = useGetEditOrActual();

  return useCallback((splitTestId: string) => state.splitTests[splitTestId]?.variants, [state.splitTests]);
};
